import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'pipeDurationStatusSimple'
})
export class PipeDurationStatusSimple implements PipeTransform {
    constructor() {}

    transform(event) {
        if(event){
            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                let diff: any = this.diff(event, event.end);
                return diff;
            } else {
                let diff: any = this.diff(event, event.start);
                return diff;
            }
        }else {
            return '';
        }
    }

    diff(event, when) {
        event.diff = moment(when).diff(moment(), 'minutes');
        return (event.diff > 58 ? (Math.round(event.diff / 60) + ' h') : (event.diff + 1) + ' min');
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDurationStatusSimple.ts